import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import "./order.less";
import moment from "moment";
import { setActiveSidebar } from "states/app-setting/app-setting.action";
import { globalValueSetLoading } from "states/global-value/global-value.action";
import { OrderModel, SearchOrderRequestModel } from "states/order/order.models";
import { PagedResult } from "states/paged-result-model";
import { getOrderListApi } from "states/order/order.api";
import { useDebouncedCallback } from "use-debounce/lib";
import { Link } from "react-router-dom";
import { formatMoney } from "shared/plugins/string-helper";
import { OrderStatusComponent } from "./order-status";
const Order = () => {
  const dispatch = useDispatch();
  const [pagedResults, setPagedResults] = useState(
    {} as PagedResult<OrderModel>
  );
  const [filterModel, setFilterModel] = useState<SearchOrderRequestModel>({
    page: 1,
    pageSize: 20,
  });
  useEffect(() => {
    dispatch(setActiveSidebar("order"));
  }, []);
  useEffect(() => {
    handleSearch.callback();
  }, [filterModel]);
  const gotoPage = async (page: number) => {
    dispatch(globalValueSetLoading(true));
    const result = await getOrderListApi({ ...filterModel, page });
    setPagedResults(result.data);
    dispatch(globalValueSetLoading(false));
  };
  const handleSearch = useDebouncedCallback(() => {
    gotoPage(1);
  }, 500);
  return (
    <React.Fragment>
      <div className="head">Danh sách đơn hàng</div>
      <div className="order-page bg-white">
        <table>
          <thead>
              <tr>
              <th>Mã đơn hàng</th>
              <th>Ngày tạo</th>
              <th>Tổng đơn hàng</th>
              <th>Trạng thái đơn hàng</th>
              </tr>
          </thead>
          <tbody>
            {pagedResults?.results?.map((model) => (
              <tr>
                <td>
                  <Link
                    to={`/account/orders/${model?.id}`}
                  >{`#${model.orderNumber}`}</Link>
                </td>
                <td>
                  {moment(model?.creationTime).format("YYYY/MM/DD hh:mm:ss A")}
                </td>
                <td>{formatMoney(model?.totalAmount)}</td>
                <td>
                  <OrderStatusComponent orderStatus={model?.orderStatus} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </React.Fragment>
  );
};
export default Order;
